import { Link } from 'react-router-dom'
import {ROUTES } from '@/constants'

// "Ready to Transform" CTA banner — sits directly above the Footer.
// Content copied verbatim from the reference, per instruction.
export default function TransformBanner() {
  return (
    <section className="transform-banner" aria-labelledby="transform-heading">
      <div className="container">
        <div className="transform-banner-inner" data-aos="fade-left">
          <div className="transform-banner-grid" aria-hidden="true" />
          <div className="transform-banner-content">
            <h2 id="transform-heading" >Bring Your Vision to Life</h2>
            <p>
              Leverage our IT experience and take a leap towards success. Let’s build something extraordinary, together.
            </p>
          </div>
          <Link  to={ROUTES.SALES_ENQUIRY} className="transform-banner-btn" >
            Get Your Free Quote<i className="fa-solid fa-arrow-right" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  )
}